import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("circle", { cx: "12", cy: "12", r: "10.25", stroke: "black", strokeWidth: "1.5", fill: "white" }),
    React.createElement("path", { d: "M18.1654 12.9055L18.1622 11.0908L12.8933 11.1065L12.8841 5.86257L11.0694 5.85938L11.0786 11.1033L5.83472 11.094L5.83791 12.9088L11.0818 12.918L11.0911 18.1619L12.9058 18.1651L12.8965 12.9212L18.1654 12.9055Z" })), 'PlusOutlined');
